/**
 * HyraMode Cart Enhancement v3.0
 * ─────────────────────────────────────────────────────
 * Features:
 *   • Cross-sell recommendations via Shopify Recs API
 *   • Cross-sell add-to-cart (AJAX, no page reload)
 *   • Animated cart count badge
 * (Removed: free-shipping bar, 3-tier VIP bars — UI no longer present)
 * ─────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || navigator.language || 'en-US';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
  };

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartSections() {
    const drawer = getCartDrawer();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map((section) => section.id);
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /* ════════════════════════════════════════════════════
     CROSS-SELL — fetch & render recommendations
     ════════════════════════════════════════════════════ */
  async function loadRecommendations() {
    const container = $('#hyra-crosssell');
    if (!container) return;
    const productId = container.dataset.productId;
    if (!productId) return;

    try {
      const res = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=4&intent=related`
      );
      const data = await res.json();
      const products = (data.products || []).filter(p => p.id != productId).slice(0, 3);
      if (!products.length) return;

      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();
      const inCartIds = new Set(cart.items.map(i => i.product_id));

      const track = $('#hyra-crosssell-track');
      if (!track) return;
      track.innerHTML = '';

      products.forEach(p => {
        if (inCartIds.has(p.id)) return;
        const variantId = p.variants?.[0]?.id;
        const price     = p.variants?.[0]?.price;
        const img       = p.featured_image || p.images?.[0];
        const imgUrl    = img ? img + '&width=256' : '';

        const el = document.createElement('div');
        el.className = 'hyra-crosssell__item';
        el.dataset.productId = p.id;
        el.innerHTML = `
          <a href="${p.url}" class="hyra-crosssell__img-wrap">
            <img src="${imgUrl}" alt="${p.title}" width="108" height="135" loading="lazy" style="object-fit:cover">
          </a>
          <div class="hyra-crosssell__info">
            <span class="hyra-crosssell__name">${p.title}</span>
            <span class="hyra-crosssell__price">${money(price)}</span>
            <button
              class="hyra-crosssell__add"
              data-variant-id="${variantId}"
              aria-label="Add ${p.title} to cart"
            >+ Add</button>
          </div>`;
        track.appendChild(el);
      });
    } catch (e) {
      console.warn('[Hyra] Recs error:', e);
    }
  }

  /* ════════════════════════════════════════════════════
     CROSS-SELL ADD TO CART (AJAX)
     ════════════════════════════════════════════════════ */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.hyra-crosssell__add');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = '...';

    try {
      const payload = {
        items: [{ id: variantId, quantity: 1 }],
        sections: getCartSections(),
        sections_url: window.location.pathname
      };
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.status === 422) throw new Error(data.description);

      btn.textContent = '✓ Added';
      btn.style.background = '#2E7D5B';

      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();
      updateCartCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      const drawer = getCartDrawer();
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        setTimeout(loadRecommendations, 250);
      }

    } catch (err) {
      btn.textContent = '+ Add';
      btn.disabled = false;
      console.warn('[Hyra] Add to cart error:', err);
    }
  });

  /* ════════════════════════════════════════════════════
     CART COUNT BADGE
     ════════════════════════════════════════════════════ */
  function updateCartCount(count) {
    $$('[data-cart-count], .cart-count-bubble').forEach(el => {
      el.textContent = count;
      el.setAttribute('aria-label', `${count} items in cart`);
      el.classList.add('hyra-badge-bump');
      setTimeout(() => el.classList.remove('hyra-badge-bump'), 400);
    });
  }

  async function refreshCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCount(cart.item_count);
    } catch (e) {}
  }

  function setDeliveryEta() {
    const nodes = $$('[data-hv-eta]');
    if (!nodes.length) return;

    const now = new Date();
    const start = new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000);
    const end = new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000);
    const format = (date) =>
      `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
    const text = `${format(start)} - ${format(end)}`;

    nodes.forEach((node) => {
      node.textContent = text;
    });
  }

  let drawerSyncTimer;
  function syncDrawerMeta() {
    window.clearTimeout(drawerSyncTimer);
    drawerSyncTimer = window.setTimeout(() => {
      setDeliveryEta();
      refreshCount();
    }, 60);
  }

  /* ════════════════════════════════════════════════════
     DAWN CART EVENTS
     ════════════════════════════════════════════════════ */
  document.addEventListener('cart:refresh', refreshCount);
  document.addEventListener('cart-drawer:open', () => {
    loadRecommendations();
    syncDrawerMeta();
  });
  document.addEventListener('cart:updated', syncDrawerMeta);

  const observer = new MutationObserver(() => {
    refreshCount();
    loadRecommendations();
  });

  function init() {
    syncDrawerMeta();
    loadRecommendations();
    const cartItems = document.getElementById('CartDrawer-CartItems');
    if (cartItems) observer.observe(cartItems, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
